/**
 * Procedure Categories and Procedures for DM in Medical Genetics students
 * Extracted with strict evidence from official NMC PDF (Page 12, 13, 29, 33: "Psychomotor domain - laboratory techniques")
 */
export const MEDICAL_GENETICS_PROCEDURES = {
  "Cytogenetic & Molecular Cytogenetic Laboratory Procedures": [
    "Chromosome Preparation, G-Banding & Karyotyping",
    "Fluorescence In Situ Hybridization (FISH) Assay & Slide Reporting",
    "Chromosomal Microarray (CMA) Analysis & Molecular Karyotyping",
    "Quantitative Fluorescent PCR (QF-PCR) & MLPA Electropherogram Analysis",
    "Skin Biopsy & Sample Processing for Cytogenetic / Molecular Studies",
  ],
  "Molecular Genetics, Sequencing & Biochemical Genetics Procedures": [
    "DNA & RNA Extraction, PCR & Real-Time Quantitative PCR (qPCR)",
    "Sanger DNA Sequencing & Chromatogram Analysis",
    "Next-Generation Sequencing (NGS) Data Analysis & In Silico Variant Annotation",
    "Hemoglobin Electrophoresis & HbA2 Estimation for Thalassemia Screening",
    "Newborn Screening (Tandem Mass Spectrometry / TMS, Urine GCMS, Plasma Amino Acid HPLC)",
    "5-Generation Family Pedigree Chart Construction & Risk Calculation",
  ],
};

export const MEDICAL_GENETICS_CATEGORIES = Object.keys(MEDICAL_GENETICS_PROCEDURES);

export const isDMInMedicalGeneticsDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("medical genetics") || d.includes("genetics");
};
